// extracted by mini-css-extract-plugin
export var aiStarSpin = "_mn-1";
export var spinner = "_mn-0";